import axios from "axios";
import { multipartUpload } from "./oss"

export async function uploadFile(type, { raw, name, id }, onProgress) {
    let res = await axios.post("file", raw, {
        params: {
            id,
            type,
            fileName: name
        },
        onUploadProgress(event) {
            onProgress ? onProgress(event.loaded / event.total) : null
        }
    })

    return res.data
}

export async function uploadTemp({ raw, name }, onProgress) {
    let res = await axios.post("file/temp", raw, {
        params: {
            fileName: name
        },
        onUploadProgress(event) {
            onProgress ? onProgress(event.loaded / event.total) : null
        }
    })

    return res.data
}

export async function asyncUploadTemp({ raw, name }, onProgress) {
    let res = await axios.get("file/temp/async", {
        params: {
            fileName: name
        }
    })

    if (res.data.type == "local") {
        await axios.post("file/temp", raw, {
            params: {
                key: res.data.key
            },
            onUploadProgress(event) {
                onProgress ? onProgress(event.loaded / event.total) : null
            }
        })

        return res.data
    }

    if (res.data.type == "oss") {
        await multipartUpload(raw, onProgress, res.data)
        return res.data
    }

    throw { message: "不能识别存储类型", res: res.data }
}

export function ConvertFileSize(fileSizeByte) {
    var fileSizeMsg = "";
    if (fileSizeByte < 1024) {
        if (fileSizeByte == null) {
            fileSizeByte = 0;
        }
        fileSizeMsg = fileSizeByte + "B"
        return fileSizeMsg;
    }
    if (fileSizeByte < 1048576) fileSizeMsg = parseInt(fileSizeByte / 1024) + "KB";
    else if (fileSizeByte == 1048576) fileSizeMsg = "1MB";
    else if (fileSizeByte > 1048576 && fileSizeByte < 1073741824) fileSizeMsg = parseInt((fileSizeByte / (1024 * 1024))) + "MB";
    else if (fileSizeByte > 1048576 && fileSizeByte == 1073741824) fileSizeMsg = "1GB";
    else if (fileSizeByte > 1073741824 && fileSizeByte < 1099511627776) fileSizeMsg = parseInt(fileSizeByte / (1024 * 1024 * 1024)) + "GB";
    else fileSizeMsg = "文件超过1TB";
    return fileSizeMsg;
}


// WEBPACK FOOTER //
// ./src/fs/index.js